<div class="channel-table">
  <div
    class="overlay"
    lumAppLoader
    [loading]="loading"
    [classes]="'loading blur'"
  ></div>

  <div class="flex justify-content-end">
    <button class="lum-button" (click)="onOpenSupplierSkuForm()">
      <i class="fas fa-plus mr-2"></i>
      Create Supplier SKU
    </button>
  </div>

  <ng-container *ngIf="pagination.total > 0; else empty">
    <lum-supplier-sku-table
      [supplierSkus]="supplierSkus"
      [config]="paginationConfig"
      [pagination]="pagination"
      (refreshSupplierSkuEvent)="onRefreshSupplierSkuEvent($event)"
    ></lum-supplier-sku-table>
    <mat-paginator
      [length]="pagination?.total || 0"
      [pageSize]="pagination?.per_page || paginationConfig.perPage"
      [pageSizeOptions]="paginationConfig.pageSizeOptions"
      [pageIndex]="(pagination?.current_page || 1) - 1"
      (page)="onPaginationEvent($event)"
      aria-label="Select page"
    >
    </mat-paginator>
  </ng-container>

  <ng-template #empty>
    <lum-ui-empty-page title="No records available."></lum-ui-empty-page>
  </ng-template>
</div>
